class VanillaInview {
  constructor(
    targetSelector = ".js-inview",
    activeClass = "--is-inview-acv",
    options = {},
    root = document,
  ) {
    this.targetSelector = targetSelector;
    this.activeClass = activeClass;
    this.root = root;

    this.inviewElements = new Map();
    this.elements = [];

    // デフォルトは1回だけ発火
    this.once = options.once ?? true;

    this.options = {
      root: options.root || null,
      threshold: options.threshold ?? 0.1,
      rootMargin: options.rootMargin || "0px",
    };

    this.observer = null;
    this.isDestroyed = false;

    this.handleIntersection = this.handleIntersection.bind(this);

    this.init();
  }

  init() {
    this.elements = this.getElements();

    if (!this.elements.length) return;

    this.observer = new window.IntersectionObserver(
      this.handleIntersection,
      this.options,
    );

    this.elements.forEach((element) => {
      this.observer.observe(element);
    });
  }

  getElements() {
    if (this.root && typeof this.root.querySelectorAll === "function") {
      return Array.from(this.root.querySelectorAll(this.targetSelector));
    }

    return Array.from(document.querySelectorAll(this.targetSelector));
  }

  handleIntersection(entries) {
    if (this.isDestroyed || !this.observer) return;

    entries.forEach((entry) => {
      if (this.isDestroyed || !this.observer) return;

      if (entry.isIntersecting) {
        // 1回だけ発火の場合、すでに発火済みなら何もしない
        if (this.once && this.inviewElements.has(entry.target)) return;

        entry.target.classList.add(this.activeClass);

        if (this.once) {
          this.inviewElements.set(entry.target, true);
          this.observer.unobserve(entry.target);
        }

        return;
      }

      // 毎回発火の場合は、画面外に出たらクラスを外す
      if (!this.once) {
        entry.target.classList.remove(this.activeClass);
      }
    });
  }

  destroy() {
    this.isDestroyed = true;

    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    if (this.inviewElements) {
      this.inviewElements.clear();
    }

    this.elements = [];
  }
}

export default VanillaInview;
